import React, { useEffect, useRef } from 'react';
import { styled } from '@mui/material';
import ReactQuill from 'react-quill-new';
import useBootstrapSize from '../../hooks/useBootstrapSize';
import { getBorderColor } from '../../theme/Components';

const CusQuill = styled(({ height, minHeight, quillRef, ...props }) => {
  // Деструктурируем props
  const theme = props.hideToolbar ? 'bubble' : 'snow';
  const isTgMode = props.isTgMode;

  let telegramToolbar = undefined;
  let telegramFormats = undefined;

  if (isTgMode) {
    telegramToolbar = [['bold', 'italic', 'underline', 'strike'], ['link'], ['clean']];

    telegramFormats = ['bold', 'italic', 'underline', 'strike', 'link', 'code-block'];
  }

  return (
    <ReactQuill
      ref={quillRef}
      modules={{ toolbar: telegramToolbar }}
      formats={telegramFormats}
      theme={theme}
      {...props}
    />
  );
})(({ theme, height, minHeight }) => {
  // Теперь переменные доступны здесь
  const isDark = theme.palette.mode === 'dark';
  const { isMobile } = useBootstrapSize();

  return {
    '&': { position: 'relative' },
    '& .ql-toolbar': {
      position: 'absolute',
      zIndex: 2,
      background: theme.palette.background.default
    },
    '& .ql-container.ql-snow': {
      paddingTop: '30px',
      minHeight: minHeight || '100px',
      height: height || '150px',
      maxHeight: '80svh',
      border: `1px solid ${getBorderColor(theme)} !important`,
      resize: 'vertical',
      overflow: 'auto'
    },
    '& .ql-editor': {
      scrollbarWidth: 'thin',
      paddingTop: isMobile && '24px'
    },
    '& .ql-picker': {
      color: `${theme.palette.text.primary} !important`
    },
    '& .ql-formats svg': { background: theme.palette.background.light },
    '& .ql-tooltip': {
      position: 'fixed !important',
      zIndex: '9999 !important',
      left: '50% !important',
      top: '50% !important',
      transform: 'translate(-50%, -50%) !important'
    }
  };
});

// Использование:
export default CusQuill;
